// api
import { getGameCover, getMainMenu } from "@/api/header";

// utils
import { formatCover } from "@/utils/methods";

// 获取游戏封面，后续后端修改数据结构后会移除
const fetchGameCover = (gameList, setGames) => {
    if (!gameList?.length) return [];

    const params = {
        game_ids: gameList.map((game) => game.id).join(','),
    }
    getGameCover(params).then((res) => {
        // results是对象，key值为游戏id
        const { results: gameCoversMap } = res.data;
        gameList = gameList.map((game) => {
            let cover_image = gameCoversMap[game.id];
            if (cover_image) {
                cover_image = formatCover(cover_image);
            }
            return {
                ...game,
                loading: false,
                cover_image: cover_image || "/images/icons/common/placeholder.jpg",
            };
        });
        setGames(gameList);
    }).catch((e) => {
        gameList = gameList.map((game) => ({
            ...game,
            loading: false,
            cover_image: "/images/icons/common/placeholder.jpg",
        }));
        setGames(gameList);
    });
};

// 获取游戏目录
export const fetchGamesMenu = async (setMainMenu) => {
    try {
        const res = await getMainMenu();
        const { results } = res.data;
        let menuList = results?.[0]?.children || [];
        
        menuList.forEach((menu) => {
            let { id } = menu;
            let childrenMenu = results.find((item) => item.parent === id)?.children || [];
            menu.children = childrenMenu;
        });
        
        menuList = menuList.map((item) => {
            return {
                ...item,
                icon: `/images/icons/menu/${item.path}.png`
            }
        });
        
        menuList.push({ 
            id: "all-game",
            name: "All Game", 
            path: "all-game",
            icon: "/images/icons/menu/all-game.png",
            children: [] 
        });

        // 如果传入了 setMainMenu 回调函数，则调用它
        if (typeof setMainMenu === 'function') {
            setMainMenu(menuList);
        }

        return menuList;
    } catch (error) {
        console.error('Error fetching games menu:', error);
        return [];
    }
};

export default fetchGameCover;